import React from 'react';
import { connect } from 'react-redux';
import { Grid, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import UserAssetsCard from './UserAssetsCard';
import EmptyGalleryLabel from '../../../common/EmptyGalleryLabel';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0) 
    },
    assetsContentWrapper: {
        padding: `${theme.spacing(2)} 0`
    }
});

const galleryCardWidth = 146;
const galleryCardHeight = 146;

const UserAssetsContainer = (props) => {
    const { classes, userAssetsInitializing, userAssets, loadMoreButton, onAssetSelect } = props;

    return (
        <Grid className={classes.assetsContentWrapper}>
            <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='flex-start'
            >
                {userAssetsInitializing ?
                    <Grid className={classes.galleryProgress}>
                        <CircularProgress />
                    </Grid>
                    :
                    userAssets && userAssets.length ?
                        userAssets.map((asset, index) =>
                            <UserAssetsCard
                                key={asset.id}
                                index={index}
                                userAsset={asset}
                                galleryCardWidth={galleryCardWidth}
                                galleryCardHeight={galleryCardHeight}
                                mediaUsageType={asset.mediaUsageType}
                                onAssetSelect={onAssetSelect}
                            />
                        )
                        :
                        <EmptyGalleryLabel text="You don't have any assets yet. Upload an image to use it here." />
                }
                {loadMoreButton}
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => {
    const { userAssetsInitializing } = state.mediaPicker;
    return { userAssetsInitializing }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(UserAssetsContainer, styles));